import { Alert } from 'antd'

import { isSystemRole } from '@/constants/roles'

import type { RoleDetail } from '../hooks/useRoleDetail'
import { RoleDescriptionCard } from './RoleDescriptionCard'
import { RolePermissionsCard } from './RolePermissionsCard'

interface Props {
  role: RoleDetail
  refetch: () => void
  canWrite: boolean
  callerPermissions: readonly string[]
}

/** Editable description + permission scopes for a single role. */
export function RoleEditor({
  role,
  refetch,
  canWrite,
  callerPermissions,
}: Props) {
  const readOnly = !canWrite || isSystemRole(role.name)

  return (
    <>
      {readOnly && (
        <Alert
          type="info"
          showIcon
          style={{ marginBottom: 16 }}
          message={
            isSystemRole(role.name)
              ? 'Built-in system roles are read-only.'
              : 'You do not have permission to change roles.'
          }
        />
      )}
      <RoleDescriptionCard role={role} refetch={refetch} readOnly={readOnly} />
      <RolePermissionsCard
        role={role}
        refetch={refetch}
        readOnly={readOnly}
        callerPermissions={callerPermissions}
      />
    </>
  )
}
